module.exports = __webpack_public_path__ + "static/media/medium.1901e039.svg";